import React from "react"
import Grid from "@material-ui/core/Grid";
import { useDispatch } from "react-redux";
import { virResetSendContactForm } from "src/actions/virActions";
import { useNavigate } from "react-router-dom";

export default function ContactSuccess({ brandStyle }) {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const linkHandler = (event) => {
        event.preventDefault();
        dispatch(virResetSendContactForm());
        navigate(brandStyle.mjpURL);
    }
    return (
        <div style={{ backgroundColor: 'white' }}>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                style={{ height: "100vh", padding: "1rem" }}
            >
                <Grid item xs={12} align="center" style={{ maxWidth: 400 }}>

                    <h2 style={{ fontFamily: brandStyle.titleFontFamily }}>
                        Thank you for your enquiry
                    </h2>
                    <div style={{ marginBottom: "1rem" }}>
                        <img src={brandStyle.checkmark} width="100px" height="100px" alt="Hertz Logo" />
                    </div>
                    <p style={{ marginTop: "4rem", fontFamily: brandStyle.textFontFamily }}>
                        We are currently reviewing it and will begin addressing your request shortly. If you require a response, please allow up to 10 working days for us to get back to you.
                    </p>
                    <hr style={{ borderColor: brandStyle.color, marginTop: "3rem", marginBottom: "3rem" }} />
                    <p style={{ margin: "2rem", fontFamily: brandStyle.textFontFamily }}>
                        To view your vehicle incident report details and photos, click the link and log into My Journey Portal.
                    </p>
                    <a id="mjpButton" onClick={linkHandler} className="btn primary" style={{
                        background: brandStyle.color, marginTop: "2rem", fontFamily: brandStyle.textFontFamily, padding: "0.8rem 2rem", borderRadius: "24px", color: brandStyle.textColor
                    }}>My Journey Portal</a>
                </Grid>
            </Grid>
        </div>
    )
}